import * as Yup from "yup";

const expenseCategorySchema = {};

expenseCategorySchema.validateExpCatAdd = () => {
  return Yup.object({
   exp_cat_name: Yup.string()
      .required("Expense Category name is required.")
      // .regex("Expense category Name already exists")
      .min(2, "Expense Category name minimum length is 2")
      .max(50, "Expense Category name should be at most 50 characters."),
      
    exp_cat_type: Yup.number().typeError('Please Choose Valid Input').required("Expense Category type is required."),
    // exp_cat_name: Yup.string() .required("Expense category Name already exists")
 
  });
};

expenseCategorySchema.validateExpCatEdit = () => {
  return Yup.object({
   exp_cat_name: Yup.string()
    .required("Expense Category name is required.")
    .min(2, "Expense Category name minimum length is 2")
    .max(50, "Expense Category name should be at most 50 characters."), 
    exp_cat_type: Yup.number().typeError('Please Choose Valid Input').required("Expense Category type is required."),
  });
};

export default expenseCategorySchema;
